import { BitkitButton, BitkitDialog, BitkitLink } from '@bitrise/bitkit-v2';
import { useDisclosure } from '@chakra-ui/react/hooks';
import { Text } from '@chakra-ui/react/text';
import { format, parseISO } from 'date-fns';
import { useContext } from 'react';

import { GlobalPropsContext } from '@/components/page/GlobalPropsContext';
import URLs from '@/enums/urls';
import { useMutateUserMetadata } from '@/hooks/api/useUserMetadata';
import { GlobalPropsWithAccount } from '@/models/GlobalProps';

const TrialUpdateDialog = () => {
  const { open, onClose } = useDisclosure({ defaultOpen: true });

  const { account } = useContext(GlobalPropsContext) as GlobalPropsWithAccount;

  const { mutate } = useMutateUserMetadata({ transform: false });

  if (!account || !account.timeBasedTrial || !account.timeBasedTrial.showUpdatedModal) {
    return null;
  }

  const onDialogClose = () => {
    mutate({ [`time_based_trial_updated_modal_closed_on_${account.slug}`]: true });
    onClose();
  };

  return (
    <BitkitDialog
      open={open}
      onOpenChange={({ open: isOpen }) => !isOpen && onDialogClose()}
      title="Free trial plan update"
      footerButtons={
        <>
          <BitkitLink
            alignSelf="center"
            colorVariant="purple"
            href={URLs.CONTACT_SALES}
            isExternal
            marginInlineEnd="auto"
          >
            Contact us
          </BitkitLink>
          <BitkitButton href={URLs.DOCUMENTATION} isExternal variant="secondary">
            Learn more
          </BitkitButton>
        </>
      }
    >
      <Text>
        We have recently changed our free trial plan offering. Starting from{' '}
        <strong>{format(parseISO(account.timeBasedTrial.migrationTime || ''), 'MMMM d, yyyy')}</strong>, your free trial
        plan will allow you to explore Bitrise for free for 30 days. Your free trial plan ends on{' '}
        <strong>{format(parseISO(account.timeBasedTrial.endTime || ''), 'MMMM d, yyyy')}</strong>.
      </Text>
      <Text>
        If you are loving having access to all of these features you can continue onto a paid plan or you can continue
        to use the Bitrise Hobby Plan for free if you are not ready to pay and want to proceed with our base tier!
      </Text>
    </BitkitDialog>
  );
};

export default TrialUpdateDialog;
